// Mapping the components with corresponding info
// from the strutture pages

// List of components
/*
* Campo - Gabbia 2v2 / 3v3 : campo1 (campo + variant ID)
* Campo - Calcetto : campo2 or campo3 (For both variant 2 and 3)
* Campo - Beach Volley : campo6
* Campo - Basket : campo4 or campo5
* Transenne : transenne (for others just lowercase and combine)
* Protezione (Giraffe) : retediprotezione
* Americane : americane
* Casetta Check-in : casettacheckin
* Gazebo Standard 3x3 : gazebostandard3x3
* Gazebo Spider 5x5 : gazebospider5x5
* Impianto Audio : impiantoaudio
* Impianto Luci  : impiantoluci
* Sabbia : sabbia
*/

import Americane from '../components/Helpers/Info/Americane'
import Audio from '../components/Helpers/Info/Audio'
import CampoBasket from '../components/Helpers/Info/CampoBasket'
import CampoBeach from '../components/Helpers/Info/CampoBeach'
import CampoCalcetto from '../components/Helpers/Info/CampoCalcetto'
import CampoGabbia from '../components/Helpers/Info/CampoGabbia'
import Casetta from '../components/Helpers/Info/Casetta'
import Gazebo3x3 from '../components/Helpers/Info/Gazebo3x3'
import Gazebo5x5 from '../components/Helpers/Info/Gazebo5x5'
import Luci from '../components/Helpers/Info/Luci'
import Protezione from '../components/Helpers/Info/Protezione'
import Sabbia from '../components/Helpers/Info/Sabbia'
import Transenne from '../components/Helpers/Info/Transenne'

export const mapping = {
  transenne: Transenne,
  americana: Americane,
  impiantoaudio: Audio,
  campo1: CampoGabbia,
  campo2: CampoCalcetto,
  campo3: CampoCalcetto,
  campo4: CampoBasket,
  campo5: CampoBasket,
  campo6: CampoBeach,
  casettacheckin: Casetta,
  gazebostandard3x3: Gazebo3x3,
  gazebospider5x5: Gazebo5x5,
  impiantoluci: Luci,
  retediprotezione: Protezione,
  sabbia: Sabbia,
  canestrobrandizzato: CampoBasket,
  retegiocobrandizzata: CampoBeach
}



// WEBPACK FOOTER //
// ./src/utils/info_mappings.js